import environment from "environment";

import { useAccessStore } from "../NoAccessScreen";
import { createBaseService } from "../utils";

export const BaseService = createBaseService({
  portalUrl: environment.portalUrl,
  refreshTokenURL: environment.api.auth + "/refresh-token",
  onPermissionDenied: (err) => {
    useAccessStore.setState(() => ({
      isDenied: true,
      message: err.response?.data.message,
    }));
  },
});
